import _JSON$stringify from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/core-js/json/stringify";
import _Date$now from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/core-js/date/now";
import _objectSpread from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/helpers/esm/objectSpread";
//
//
//
//
//
//
//
import cookie from '@tencent/vft-common/cookie';
import sha1 from '@/util/sha1';
import clipboard from '@tencent/simple-clipboard/src/index';
import { mapState } from 'vuex';
export default {
  name: 'to-yoo-button',
  props: ['hgptag'],
  computed: _objectSpread({}, mapState(['isLogin'])),
  methods: {
    clickHnadler: function clickHnadler() {
      if (!this.isLogin) {
        this._openLogin();

        return false;
      }

      try {
        window.appBanner.setConfig({
          pageId: '40004001',
          //页面ID(选填)
          ptag: this.hgptag //分享源(选填)，如果不填，会自动从url地址栏搜索hgptag和ptag关键参数

        });
        window.appBanner.isInstalled();
      } catch (e) {
        console.error(e);
      }

      var hgptag = this.hgptag; // 视频活动主页
      // let hgptag = 'eggtxvideotx' // 视频点击提现

      var vuid = cookie.get('vuserid');
      var h5url = encodeURIComponent('https://yoo.qq.com/biu/egg_activity_tasks?hgptag=' + hgptag + '&vuid=' + vuid);
      var openUrl = "firevideo://v.qq.com/H5Page?url=".concat(h5url, "&wv=wk");
      var content = {
        'scence': '',
        'scenceid': '',
        'extral': {
          'vids': [],
          'intervene_personid': '',
          'intervene_topicid': ''
        },
        'start_time_stamp': _Date$now(),
        'validate_time_interval': 60 * 60 * 1000,
        'validate_count': 1,
        'rectype': '',
        'intertype': '',
        'from': '',
        'action': openUrl,
        'newInstallOnly': 0
      };
      var sha1Str = sha1(_JSON$stringify(content) + 'g8895e3efc56875976cd25914839gfc858e7hh');

      var final = _JSON$stringify({
        'launch_rec_request': {
          'content': _JSON$stringify(content),
          'sha1': sha1Str
        }
      });

      clipboard.copy(final, function (ret) {
        // 不需要判断ret是否写成功
        window.appBanner.webOpenApp(openUrl);
      });
    }
  }
};